import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateFreight } from '../../store/ducks/tables/actions';
import { GetPaymentOrdersResponseRow } from '../payment-orders/useGetPaymentOrders';

export interface useGetPaymentOrderGroupsResponse {
  page: string;
  rows: useGetPaymentOrderGroupsResponseRow[];
  totalRecords: number;
}

export interface useGetPaymentOrderGroupsResponseRow {
  paymentOrderGroupId: string;
  amount: string;
  groupName: string;
  createdAt: Date;
  updatedAt: Date;
  paidAt: Date;
  paymentOrders: GetPaymentOrdersResponseRow[];
}

export default function useGetPaymentOrderGroups() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page?: number;
    rowsPerPage?: number;
    status?: string;
  }): Promise<useGetPaymentOrderGroupsResponse | undefined> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/payment-order-groups', {
        params: {
          page: params.page,
          rowsPerPage: params.rowsPerPage || 20,
        },
      });

      if (response.status === 200) {
        dispatch(populateFreight(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
